import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/components/Mitarbeiter';
import { Fragment } from 'react/jsx-runtime';
import { CSSProperties } from 'react';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { RowDivider } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/components/RowDivider';
import { MitarbeiterKalenderInterval } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/components/station/MitarbeiterKalenderInterval';
import { mapMitarbeiterKalenderIntervals } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/utils/mapMitarbeiterKalenderIntervals';
import { KalenderByMitarbeiterStation } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByMitarbeiter/KalenderStation';

type StylePropsGrid = CSSProperties & {
  '--col-count': CSSProperties['gridTemplateColumns'];
};

export function renderRotationsplaeneByMitarbeiterRow({
  rotationsplaene,
  weeksInYear,
  endOfYear,
  startOfYear,
  jahr,
}: {
  rotationsplaene: Rotationsplan[];
  weeksInYear: number;
  endOfYear: dayjs.Dayjs;
  startOfYear: dayjs.Dayjs;
  jahr: string;
}) {
  return rotationsplaene.map((rotationsplan) => {
    const intervalle = mapMitarbeiterKalenderIntervals({
      rotationsplan,
      startOfYear,
      endOfYear,
    });

    return (
      <Fragment key={rotationsplan.id}>
        <Mitarbeiter
          lehrjahr={rotationsplan.currentLehrjahr}
          mitarbeiter={rotationsplan.mitarbeiter}
          beruf={rotationsplan.beruf}
        />
        <div
          className={`grid grid-rows-[repeat(2, auto)] grid-cols-subgrid col-start-2 col-end-(--col-count)`}
          style={
            {
              '--col-count': weeksInYear * 7,
            } as StylePropsGrid
          }>
          {intervalle.map(({ id, interval, hasOverlaps }) => {
            const konfliktStationen =
              interval instanceof KalenderByMitarbeiterStation
                ? rotationsplan.getUeberschneidendeStationen(interval.station)
                : [];

            return (
              <MitarbeiterKalenderInterval
                key={id}
                interval={interval}
                displayYear={parseInt(jahr)}
                hasOverlaps={hasOverlaps}
                konfliktStationen={konfliktStationen}
              />
            );
          })}
        </div>
        <RowDivider />
      </Fragment>
    );
  });
}
